/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import jwt from "jsonwebtoken";
// import axios from "axios";
import { withRouter } from "react-router-dom";
// import { createBrowserHistory } from "history";
import { ThemeProvider } from "@material-ui/styles";
import validate from "validate.js";
// import {speedTest} from 'speedtest-net'

// import { chartjs } from "./helpers";
import theme from "./theme";
// import 'react-perfect-scrollbar/dist/css/styles.css';
import { createTheme } from "@material-ui/core/styles";

import "./assets/scss/index.scss";
import validators from "./common/validators";
import Routes from "./Routes";
// common util
// import { userAgentDetection } from "common/common-util-functions";

// action
import {
  getDiagnosableModel,
  getNetSpeed,
  updateUserAgent,
  getNetConnectivity,
  // getSymptoms,
  getReportContent,
  getOrgzFeaturesAction,
  getrecommendationsList,
  getDiagnosticTests,
} from "actions/global-action";
import { getPatientsList } from "actions/patient-action";

import {
  getConsultantDataForTheCurrentUserAction,
  getuserDetailNew,
  getUserSettings,
} from "actions/user-action";
import { getBulkImgList } from "actions/bulk-upload-action";
// db
import { createDb } from "database/offlineDb/indexDb";
import { useCookies } from "react-cookie";
import { orangeTheme, blueTheme } from "theme/palette";
import { checkIfObjectIsEmpty } from "helpers/common";
import {
  getAuthTokenFromSessionStorage,
  subscribeToAuthTokenChanges,
} from "helpers/auth-session";
import { baseURL } from "database/onlineDb/baseUrl";
import { MlStatusRepositoryProvider } from "./realtime/mlStatusContext";
import { EntitlementRepositoryProvider } from "./realtime/entitlementContext";
import { getEntitlementProjection, saveEntitlementProjection } from "./database/offlineDb/indexDb";
import { isMlEntitlementEnabled } from "./realtime/entitlementMode";
import { useRealtimeClient } from "./realtime/useRealtimeClient";
import { useEntitlementProjectionRepository } from "./realtime/useEntitlementProjectionRepository";
import { replaceEntitlementProjection } from "./reducers/entitlement-reducer";
import PatientUploadRealtimeOwner from "./realtime/PatientUploadRealtimeOwner";
import ViewPatientRealtimeOwner from "./realtime/ViewPatientRealtimeOwner";
import BulkUploadRealtimeOwner from "./realtime/BulkUploadRealtimeOwner";
import ViewImagesRealtimeOwner from "./realtime/ViewImagesRealtimeOwner";
//data

validate.validators = {
  ...validate.validators,
  ...validators,
};

let themeData = [
  { themeName: "orangeTheme", value: orangeTheme },
  { themeName: "blueTheme", value: blueTheme },
];
const socketIOUrl = baseURL.replace(/\/telemed\/?$/, "");

export const App = (props) => {
  const readAuthToken =
    props.realtimeGetAuthToken || getAuthTokenFromSessionStorage;
  const subscribeAuthToken =
    props.realtimeSubscribeToAuthTokenChanges || subscribeToAuthTokenChanges;
  const [authToken, setAuthToken] = useState(readAuthToken);
  const noAiSetting = props.userStore?.userProfile?.no_ai_annotation;
  const entitlementEnabled = isMlEntitlementEnabled(noAiSetting);
  const entitlementRepoRef = useRef(null);
  const realtimeOwner = useRealtimeClient({
    authToken,
    url: socketIOUrl,
    ioFactory: props.realtimeIoFactory,
    repositoryFactory: props.realtimeRepositoryFactory,
    onError: props.realtimeOnError,
    entitlementRepositoryRef: entitlementRepoRef,
  });
  const entitlementOwner = useEntitlementProjectionRepository({
    client:
      realtimeOwner && realtimeOwner.token === authToken
        ? realtimeOwner.client
        : null,
    authToken,
    enabled: entitlementEnabled,
    orgId: props.userStore?.userProfile?.orgz_id,
    entitlementRepositoryFactory: props.entitlementRepositoryFactory,
    loadProjection: props.entitlementLoadProjection,
    getCachedProjection: getEntitlementProjection,
    saveCachedProjection: saveEntitlementProjection,
    onProjectionState: props.replaceEntitlementProjection,
    onError: props.realtimeOnError,
    repositoryRef: entitlementRepoRef,
  });
  const [cookies, setCookie] = useCookies([]);
  const [mobileViewTopButtonsPadding, setMobileViewTopButtonsPadding] =
    useState(false);
  const [themeColor, setThemeColor] = React.useState({
    themeName: "blueTheme",
  });
  useEffect(() => {
    if (window.innerWidth > 959 && mobileViewTopButtonsPadding)
      return setMobileViewTopButtonsPadding(false);

    if (
      (window.location.href.includes("view-images") &&
        props.viewImagesStore?.selectedViewImagesList.length > 0) ||
      (window.location.href.includes("bulk-upload") &&
        props.bulkUploadImageStore.selectedBulkImageList?.length > 0) ||
      (window.location.href.includes("view-patients") &&
        props.viewPatientStore?.selectedViewPatientList.length > 0) ||
      ((window.location.href.includes("patients") ||
        props.patientStore?.selectedPatientList.length > 0) &&
        !mobileViewTopButtonsPadding)
    ) {
      window.innerWidth < 959 && setMobileViewTopButtonsPadding(true);
    } else if (
      mobileViewTopButtonsPadding &&
      ((props.bulkUploadImageStore.selectedBulkImageList?.length === 0 &&
        window.location.href.includes("bulk-upload")) ||
        (props.viewImagesStore?.selectedViewImagesList.length === 0 &&
          window.location.href.includes("view-images")) ||
        (props.viewPatientStore?.selectedViewPatientList.length === 0 &&
          window.location.href.includes("view-patients")) ||
        (props.patientStore?.selectedPatientList.length === 0 &&
          window.location.href.includes("patients")))
    ) {
      return setMobileViewTopButtonsPadding(false);
    } else if (
      mobileViewTopButtonsPadding &&
      !(
        window.location.href.includes("patients") ||
        window.location.href.includes("bulk-upload") ||
        window.location.href.includes("view-images") ||
        window.location.href.includes("view-patients")
      )
    ) {
      return setMobileViewTopButtonsPadding(false);
    }
  }, [
    window.innerWidth,
    window.location.href,
    props.bulkUploadImageStore.selectedBulkImageList?.length,
    props.viewPatientStore?.selectedViewPatientList?.length,
    props.viewImagesStore?.selectedViewImagesList?.length,
  ]);

  useEffect(() => {
    setThemeColor({
      themeName: parseThemeValue(props.globalStore.themeName, themeData),
    });
  }, [props.globalStore.themeName]);
  useEffect(() => {
    createDb();
    props.getuserDetailNew();

    if (props.needToGetUserSettings) {
      props.getUserSettings();
    }

    props.getPatientsList();
    props.getBulkImgList();
    handleConnectionChange();
    props.getReportContent();
    if (readAuthToken() && !props.globalStore?.orgzFeatures) {
      props.getConsultantDataForTheCurrentUser(props.getOrgzFeaturesAction);
    }

    if (cookies.palette !== undefined) {
      setThemeColor({
        themeName: parseThemeValue(cookies.palette.themeName, themeData),
      });
    } else {
      setCookie("palette", { themeName: "blueTheme" }, { path: "/" }, "high");
      setThemeColor({ themeName: parseThemeValue("blueTheme", themeData) });
    }
  }, []);

  useEffect(() => {
    return subscribeAuthToken(setAuthToken);
  }, [subscribeAuthToken]);

  // useEffect(() => {}, [Boolean(!props.globalStore?.orgzFeatures)]);

  const parseThemeValue = (label, array) => {
    let value = "";
    for (let i = 0; i < array.length; i++) {
      if (array[i].themeName === label) {
        value = array[i].value;
      }
      // else{
      //   value=array[0].value
      // }
    }
    return value;
  };
  const handleConnectionChange = () => {
    props.getNetConnectivity();
  };
  useEffect(() => {
    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);
    return () => {
      window.removeEventListener("online", handleConnectionChange);
      window.removeEventListener("offline", handleConnectionChange);
    };
  }, []);
  // alert()
  return (
    <ThemeProvider
      theme={createTheme({
        ...theme,
        palette: { ...themeColor.themeName },
      })}
    >
      {props.globalStore?.connection === false && (
        <div
          data-offline-banner="true"
          role="status"
          aria-live="polite"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2000,
            padding: "6px 16px",
            textAlign: "center",
            backgroundColor: "#b26a00",
            color: "#ffffff",
            fontSize: "13px",
          }}
        >
          You are offline. Waiting for the network to come back…
        </div>
      )}
      {mobileViewTopButtonsPadding && <div style={{ height: "35px" }}></div>}
      <MlStatusRepositoryProvider
        repository={
          realtimeOwner && realtimeOwner.token === authToken
            ? realtimeOwner.repository
            : null
        }
      >
        <EntitlementRepositoryProvider
          repository={
            entitlementOwner && entitlementOwner.token === authToken
              ? entitlementOwner.repository
              : null
          }
        >
          <Routes />
          <PatientUploadRealtimeOwner authToken={realtimeOwner?.token} />
          <ViewPatientRealtimeOwner authToken={realtimeOwner?.token} />
          <BulkUploadRealtimeOwner authToken={realtimeOwner?.token} />
          <ViewImagesRealtimeOwner authToken={realtimeOwner?.token} />
        </EntitlementRepositoryProvider>
      </MlStatusRepositoryProvider>
    </ThemeProvider>
  );
};
// console.log("image" + props.bulkUploadImageStore.selectedBulkImageList);
function mapStateToProps(store) {
  return {
    globalStore: store.globalStore,
    patientStore: store.patientStore,
    bulkUploadImageStore: store.bulkUploadImageStore,
    userStore: store.userStore,
    viewImagesStore: store.viewImagesStore,
    viewPatientStore: store?.viewPatientStore,
    needToGetUserSettings:
      store?.userStore?.userSettings &&
      checkIfObjectIsEmpty(store?.userStore?.userSettings),
    needToGetUserDetails:
      store?.userStore?.userDetails &&
      checkIfObjectIsEmpty(store?.userStore?.userDetails),
    consultantDetails: store.userStore?.userProfile?.consultantDetails,
  };
}
export default connect(mapStateToProps, {
  getDiagnosableModel,
  updateUserAgent,
  getNetSpeed,
  getPatientsList,
  getuserDetailNew,
  getBulkImgList,
  getNetConnectivity,
  getConsultantDataForTheCurrentUser: getConsultantDataForTheCurrentUserAction,
  getOrgzFeaturesAction,
  getrecommendationsList,
  getDiagnosticTests,
  // getSymptoms,
  getReportContent,
  getUserSettings,
  replaceEntitlementProjection,
})(withRouter(App));
